module.exports = __webpack_public_path__ + "img/diagram-sankey.a09a8775.svg";